import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Year} from './year';


@Injectable()
export class YearService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('years?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('years/' + _id).map((response: Response) => response.json());
  }
  getlastyear() {
    return this.http.get('years/getlast' ).map((response: Response) => response.json());
  }
  lastYear() {
    return this.http.get('years/last' ).map((response: Response) => response.json());
  }
  haveDocs(id) {
    return this.http.get('years/haveDocs/' + id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('years/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('years/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(year: Year) {
    return this.http.post('years', year).map((response: Response) => response.json());
  }

  update(year: Year) {
    return this.http.put('years/' + year.year, year).map((response: Response) => response.json());
  }

  checkfound(_id: string) {
    return this.http.get('yearsfound/' + _id).map((response: Response) => response.json());
  }

  checkDateOverlap(_sdate: string,_edate: string) {
      return this.http.get('checkDateOverlap/' + _sdate + "/" + _edate).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('years/' + _id);
  }

  switchYear(data: any) {
    return this.http.put('user/auth', data).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/years/year.service.ts